export default "__VITE_ASSET__CZi_k88$__"